import type { AgentRole } from '../lib/api';
import { AGENT_TYPE_COLORS, PHASE_COLORS } from '../lib/utils';

interface Props {
  agent: AgentRole;
  onClick: () => void;
  onDelete: () => void;
  readOnly?: boolean;
}

export function AgentRoleCard({ agent, onClick, onDelete, readOnly }: Props) {
  const typeColor = AGENT_TYPE_COLORS[agent.type] || 'bg-gray-500/20 text-gray-400 border-gray-500/30';

  return (
    <div
      onClick={onClick}
      className="group relative cursor-pointer rounded-xl border border-gray-800 bg-surface-850 p-4 transition-all hover:border-gray-700 hover:bg-surface-800"
    >
      {!readOnly && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          className="absolute right-2 top-2 rounded p-1 text-gray-600 opacity-0 transition-opacity hover:bg-gray-800 hover:text-gray-400 group-hover:opacity-100"
        >
          <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}

      <div className="mb-2 flex items-center gap-2">
        <h4 className="text-sm font-semibold text-gray-100">{agent.name}</h4>
      </div>

      <span className={`inline-block rounded-full border px-2 py-0.5 text-[10px] font-medium ${typeColor}`}>
        {agent.type}
      </span>

      {agent.phases.length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1">
          {agent.phases.map((phase) => (
            <span
              key={phase}
              className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${PHASE_COLORS[phase] || 'bg-gray-500/20 text-gray-400'}`}
            >
              {phase}
            </span>
          ))}
        </div>
      )}

      <div className="mt-3 text-[10px] text-gray-600">
        <span>{agent.settings.model}</span>
      </div>
    </div>
  );
}
